import Campaign from "@/components/campaign/Campaign";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { getSmsData } from "@/services/axios/get-sms-data";
const bannersData = [
  {
    id: 1,
    img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/golf-car.png",
  },
  {
    id: 2,
    img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle.png",
  },
  {
    id: 3,
    img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/car.png",
  },
  {
    id: 4,
    img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior.png",
  },
  {
    id: 5,
    img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/shopping.png",
  },
];
export default function Index({bannersData = []}) {
  const { t } = useI18n();
  return (
    <>
      <Box
        className="section-safe-padding-top"
        sx={{
          width: "100%",
          overflow: "hidden",

          "& .offersSwiper": {
            overflow: { xs: "visible", lg: "hidden" },
            mx: { xs: 6, lg: 8 },
          },

          "& .swiper-slide": {
            display: "flex",
            justifyContent: "center",
            transition: "transform .5s ease",
            transform: "scale(.85)",
          },

          "& .swiper-slide-active": {
            transform: "scale(1)",
            zIndex: 2,
          },

          "& .slideCard": {
            width: "100%",
            borderRadius: "14px",
            overflow: "hidden",
          },

          "& .slideImage": {
            width: "100%",
            display: "block",
            borderRadius: "14px",
          },
        }}
      >
        <Swiper
          dir="ltr"
          modules={[Autoplay]}
          loop
          centeredSlides
          slidesPerView={1.2}
          spaceBetween={5}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            500: { slidesPerView: 1.5 },
            1200: { slidesPerView: 3 },
          }}
          className="offersSwiper"
        >
          {bannersData.map((item) => (
            <SwiperSlide key={item.id}>
              <Box className="slideCard">
                <Box
                  component="img"
                  src={item.img}
                  alt={`banner-${item.id}`}
                  className="slideImage"
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      <Box className="horizontal-safe-padding vertical-safe-padding">
        <Campaign
          type="sms"
          title={t.Campaign.catalogueTitle}
          subTitle={t.Campaign.catalogueSubTitle}
          source={process.env.NEXT_PUBLIC_MODE === "PRODUCTION" ? 198 : 200}
          isCatalogueStyle={false}
          isCenter={true}
        />
      </Box>
    </>
  );
}

export async function getServerSideProps({ res }) {
  try { 
    res.setHeader(
      "Cache-Control",
      "no-store, no-cache, must-revalidate, proxy-revalidate"
    );

    const { bannersData } = await getSmsData();

    return {
      props: {
        bannersData: bannersData || [],
      },
    };
  } catch (error) {

    return {
      props: {
        bannersData: [],
      },
    };
  }
}